import type { ReactNode } from 'react';
import { Alert, Button, Card, Icon, cn } from '@evogard/ui';

/**
 * A moldura comum dos cartões: o erro diz que nada foi desenhado, o
 * carregamento é esqueleto, e o vazio é frase — nunca zero desenhado.
 */
export function PanelCard({
  title,
  descricao,
  query,
  empty,
  asTable,
  onToggle,
  toggleLabel = 'gráfico',
  skeleton = 'h-56',
  className,
  children,
  caption,
}: {
  title: string;
  descricao: string;
  query: { data?: unknown; isError: boolean; error: Error | null };
  /** A frase quando a resposta não tem o que desenhar; `null` quando tem. */
  empty: string | null;
  asTable: boolean;
  onToggle: () => void;
  toggleLabel?: string;
  skeleton?: string;
  className?: string;
  children: ReactNode;
  caption?: ReactNode;
}) {
  const ready = !!query.data && !query.isError && empty === null;
  return (
    <Card
      as="figure"
      className={className}
      title={title}
      descricao={descricao}
      actions={
        ready && (
          <Button variant="discreto" size="sm" onClick={onToggle}>
            <Icon nome={asTable ? 'grafico' : 'grade'} size={16} />
            {asTable ? `Ver ${toggleLabel}` : 'Ver tabela'}
          </Button>
        )
      }
    >
      {query.isError ? (
        <Alert tone="erro" title={`Não conseguimos carregar: ${title.toLowerCase()}`}>
          Nada foi desenhado, para não mostrar número velho como se fosse atual.
          <span className="mt-1 block font-mono text-xs">{query.error?.message}</span>
        </Alert>
      ) : !query.data ? (
        <div
          className={cn(skeleton, 'animate-pulse rounded-borda bg-superficie-suave')}
          aria-busy="true"
        />
      ) : empty !== null ? (
        <p className="py-10 text-center text-sm text-texto-suave">{empty}</p>
      ) : (
        children
      )}
      {ready && caption && (
        <figcaption className="mt-3 text-xs text-texto-suave">{caption}</figcaption>
      )}
    </Card>
  );
}
